import React from 'react'

import { 
	TextField, FormControl, InputLabel, Select, MenuItem,
	Card, CardContent, CardActions, Typography,
	Dialog, Button
} from '@material-ui/core'

import TagsInput from './TagsInput'
import MultipleChoice from './MultipleChoice'

const Config = require('../../config')

export default class NewQuestionEditor extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
			loading: false,
			errors: {},

			text: '',
			tags: '',
			topic: 0,
			type: 0,
			customData: '',
			id: null
		}

		this.multipleChoice = React.createRef()
	}

	getData() {
		let data = this.state.customData

		if (this.state.type == 2) {
			data = this.multipleChoice.current.getData().join('\n')
		}

		return {
			text: this.state.text,
			tags: this.state.tags.split(' '),
			topic: this.state.topic,
			type: this.state.type,
			customData: data,
			isNew: this.state.id == null,
			id: this.state.id
		}
	}

	handleChange(who, e) {
		let value = e.target.value

		if (who == 'text') {
			this.setState({
				text: value
			})
		} else if (who == 'tags') {
			this.setState({
				tags: value
			})
		} else if (who == 'topic') {
			this.setState({
				topic: value
			})
		} else if (who == 'type') {
			this.setState({
				type: value
			})
		} else if (who == 'data') {
			this.setState({
				customData: value
			})
		}
	}

	open(id, data) {
		this.setState({
			open: true,
			id: id
		}, () => {
			if (data) {
				let d = data.type == 2 ? (data.customData ? data.customData.split('\n') : [ '', '' ]) : ''

				this.setState({
					id: data.id,
					text: data.text,
					tags: data.tags.join(' '),
					topic: data.topic,
					type: data.type,
					customData: d
				})
			}
		})
	}

	close(self, added) {
		if (this.props.onClose) {
			this.props.onClose(added)
		}

		this.setState({
			open: false,

			text: '',
			tags: '',
			topic: 0,
			type: 0,
			customData: '',
			id: null
		})
	}

	showError(field, message) {
		let errors = {}
		errors[field] = message

		this.setState({
			errors: errors
		})
	}

	validate() {
		if (this.state.text.length == 0) {
			return this.showError('text', 'Please, input a question')
		}

		return true
	}

	create(e) {
		e?.preventDefault()

		if (this.validate()) {
			this.close(null, true)
		}
	}

	render() {
		return (
			<Dialog modal="true" open={this.state.open} onBackdropClick={this.close.bind(this)}>
				<form onSubmit={this.create.bind(this)}>
					<Card style={{ minWidth: 500, padding: 16 }}>
						<CardContent>
							<Typography gutterBottom>
								{this.state.id != null ? 'Edit the question' : 'Create a new question'}
							</Typography>
							<br/>
							
							{ this.renderForm() }
						</CardContent>
						<CardActions>
							<Button onClick={this.create.bind(this)} color="primary" variant="contained" type="submit">
							{this.state.id != null ? 'Update' : 'Create'}
							</Button>
							<Button onClick={this.close.bind(this)} variant="contained">Cancel</Button>
						</CardActions>
					</Card>
				</form>
			</Dialog>
		)
	}

	handleSelecetedTags(tags) {
		this.setState({
			tags: tags
		})
	}

	renderForm() {
		if (!this.state.open || !Config.server.question) {
			return
		}

		return (
			<>
				<TextField autoFocus fullWidth error={this.state.errors['text'] && true || false}
				  InputLabelProps={{ shrink: true }}  
					multiline
					disabled={this.state.loading} variant="outlined" label={this.state.errors['text'] || 'Question'} 
					value={this.state.text} onChange={this.handleChange.bind(this, 'text')} style={{ minHeight: '100%', height: '100%' }}
				/>
				<br/><br/>

				<FormControl fullWidth>
					<InputLabel id="type-label">Question Type</InputLabel>
					<Select
						labelId="type-label"
						value={this.state.type}
						label="Question Type"
						id="type-list"
						onChange={this.handleChange.bind(this, 'type')}
					>
						{Config.server.question.types.map((value, index) =>
							<MenuItem value={index}>{value}</MenuItem>
						)}
					</Select>
				</FormControl>
				<br/><br/>

				<FormControl fullWidth>
					<InputLabel id="topic-label">Topic</InputLabel>
					<Select
						labelId="topic-label"
						value={this.state.topic}
						label="Question Topic"
						id="topic-list"
						onChange={this.handleChange.bind(this, 'topic')}
					>
						{this.props.topics.map((value, index) =>
							<MenuItem value={index}>{value}</MenuItem>
						)}
					</Select>
				</FormControl>
				<br/><br/>

				<TextField fullWidth error={this.state.errors['tags'] && true || false} 
					InputLabelProps={{ shrink: true }}  
					// selectedTags={this.handleSelecetedTags.bind(this)}
					disabled={this.state.loading} variant="outlined" label={this.state.errors['tags'] || 'Tags'} 
					value={this.state.tags} onChange={this.handleChange.bind(this, 'tags')} style={{ minHeight: '100%', height: '100%' }}
				/>

				{this.renderDataForm()}
			</>
		)
	}

	renderDataForm() {
		const type = Config.server.question.types[this.state.type]

		if (type == 'multichoice') {
			return <>
				<h4>Variants</h4>
				<MultipleChoice data={this.state.customData} ref={this.multipleChoice} disabled={this.state.loading} />
				<br/>
					{this.state.errors['variants']}
				<br/>
			</>
		}
	}
}